import {
  addDesignerProjectColor,
  deleteDesignerProjectColor,
  listDesignerProjectColors,
  updateDesignerProjectColor
} from "../../designer-project-color-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const projectColorTools: ToolHandlerGroup = {
  sync: {
    ui_style_list_project_colors: () => listDesignerProjectColors(getSdInstance()),
    ui_style_add_project_color: (input) => addDesignerProjectColor(getSdInstance(), input),
    ui_style_delete_project_color: (input) => deleteDesignerProjectColor(getSdInstance(), input.id)
  },
  async: {
    ui_style_update_project_color: async (input) => updateDesignerProjectColor(getSdInstance(), input)
  }
};
